<ng-template #otworz i18n>Otwórz kalendarz</ng-template>
<div class="relative">
  <div class="absolute m-0 w-0 border-none p-0">
    <input
      class="cdk-visually-hidden"
      tabindex="-1"
      ndtDatepicker
      #datepicker="ndtDatepicker"
      outsideDays="hidden"
      [autoClose]="'outside'"
      [datepickerClass]="'ndt'"
      [displayMonths]="displayMonths"
      [dayTemplate]="dayTemplate"
      [positionTarget]="readonlyInput"
      [footerTemplate]="footerTemplate"
      [startDate]="startDate"
      (closed)="onClosed()"
      (dateSelect)="onDateSelection($event)"
    />

    <ng-template #dayTemplate let-currentMonth="currentMonth" let-date let-selected="selected" let-today="today">
      <span
        class="relative inline-flex h-6 w-6 items-center justify-center rounded-full text-sm hover:bg-primary-300 hover:text-secondary"
        [ngClass]="{
          'bg-primary-100': isHovered(date) || isInside(date),
          'bg-primary-400 font-bold': today && !isRange(date),
          'bg-primary-500': (isRange(date) && !(isHovered(date) || isInside(date))) || selected,
          'text-white':
            (today && !isRange(date)) || (isRange(date) && !(isHovered(date) || isInside(date))) || selected,
          'text-secondary-300': isOutsideMonth(date, currentMonth) || isWeekend(date),
          'before:absolute before:right-0 before:-z-10 before:inline-block before:h-2 before:w-10 before:bg-primary-100':
            ((isRange(date) && !isRangeStart(date)) || isCurrentlyHovered(date)) &&
            !isMonthStart(date) && !isWeekStart(date)
        }"
        (mouseenter)="hoveredDate = date"
        (mouseleave)="hoveredDate = null"
      >
        {{ date.day }}
      </span>
    </ng-template>
    <ng-template #footerTemplate>
      <div class="flex justify-between bg-neutral-100 px-4 py-2">
        <button
          ndt-tertiary-button
          type="button"
          [disabled]="disabled || !fromDate?.value"
          (click)="clear(); datepicker.close()"
          i18n
        >
          Wyczyść
        </button>
      </div>
    </ng-template>
  </div>

  <div class="input-group relative">
    <input
      #readonlyInput
      readonly
      type="text"
      [id]="inputId"
      class="form-control cursor-auto pr-8"
      [ngClass]="{ 'is-invalid': (fromDate.invalid && fromDate.touched) || (toDate.invalid && toDate.touched) }"
      autocomplete="off"
      [placeholder]="placeholder"
      [value]="value"
    />
    <button
      ndt-icon-button
      type="button"
      class="absolute right-0 top-1 z-10 pr-2"
      [disabled]="toDate.disabled || fromDate.disabled || disabled"
      [ngbTooltip]="otworz"
      (click)="datepicker.toggle()"
    >
      <app-icon name="calendar"></app-icon>
    </button>
  </div>
</div>
